import React, { useEffect, useMemo, useState } from "react";
import PermissionButton from "../../../shared/PermissionButton";
import {
  useAssessment,
  useAssessmentConfiguration,
  useCopyPreviousAssessment,
} from "../../../../hooks/useAssessment";
import AssessmentForm from "./AssessmentForm";
import Select from "../../../shared/Select";

const CreateAssessment = ({ name }) => {
  const { assessments, refetchAssessment: refetchPreviousAssessment } =
    useAssessment();
  const {
    assessmentConfiguration,
    setAssessmentConfiguration,
    getAssessmentConfiguration,
    loading,
  } = useAssessmentConfiguration();
  const [copiedId, setCopiedId] = useState(null);

  const assessmentsOption = useMemo(() => {
    if (assessments?.length === 0) return [];

    return assessments?.map((item) => ({
      label: item.assessmentName,
      value: item.id,
      assessmentTypeCode: item.assessmentTypeCode,
    }));
  }, [assessments]);

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>Create Assessment</h1>
          <div className="arr-btns-group">
            <div className="flex">
              <Select
                options={assessmentsOption}
                value={
                  assessmentsOption?.find((opt) => opt?.value === copiedId) ||
                  null
                }
                placeholder="Import Previous Assessment Configuration"
                onChange={(option) => {
                  if (!option) {
                    setAssessmentConfiguration(null);
                    setCopiedId(null);
                    return;
                  }
                  getAssessmentConfiguration(option?.value);
                  setCopiedId(option?.value);
                }}
                isClearable={false}
                styles={{
                  control: { width: "350px" },
                }}
              />
            </div>
            <PermissionButton
              moduleName={"Recording Setup"}
              widgetName={name}
              header={"Create Assessment"}
              activityName={"insert-assessment"}
            />
          </div>
        </div>

        <AssessmentForm
          type="create"
          assessmentConfiguration={assessmentConfiguration}
          copiedId={copiedId}
          isFetching={loading.read}
          setAssessmentConfiguration={setAssessmentConfiguration}
          refetchPreviousAssessment={refetchPreviousAssessment}
        />
      </div>
    </>
  );
};

export default CreateAssessment;
